"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      id: '',
      moduleId: '',
      dialogVisible: false,
      ruleForm: {
        subTitle: '',
        categoryName: '',
        sort: '',
        status: ''
      },
      rules: {
        subTitle: [{
          required: false
        }],
        categoryName: [{
          required: false
        }],
        status: [{
          required: false
        }],
        sort: [{
          required: false
        }]
      }
    };
  },
  methods: {
    open: function open(data) {
      var _this = this;
      this.moduleId = data.moduleId;
      (0, _customPage.bannerDetail)({
        bannerId: data.bannerId,
        type: data.type
      }).then(function (res) {
        console.log(res.data.categoryData, '999999999999999999999999');
        if (res.data.categoryData != null) {
          _this.id = res.data.categoryData.categoryId;
          _this.ruleForm.categoryName = res.data.categoryData.categoryName;
          _this.ruleForm.subTitle = res.data.categoryData.subTitle;
          _this.ruleForm.status = res.data.categoryData.status;
          _this.ruleForm.sort = res.data.categoryData.sort;
        }
      });
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        subTitle: '',
        categoryName: '',
        sort: '',
        status: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _customPage.saveOrUpdateBanner)({
            moduleId: _this2.moduleId,
            categoryData: {
              categoryId: _this2.id,
              categoryName: _this2.ruleForm.categoryName,
              subTitle: _this2.ruleForm.subTitle,
              status: _this2.ruleForm.status,
              sort: _this2.ruleForm.sort
            }
          }).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.$emit('refresh');
              _this2.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};